import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import PageLayout from '../app/layout/PageLayout';
import { useAppDispatch } from '../app/redux/useAppSelector';
import PageMeta from '../utils/PageMeta';
import { redirectOnNotFoundError } from '../utils/error/useErrorRedirectEffect';
import useNavigate from '../utils/router/useNavigate';
import { parseSlug } from '../utils/router/useSlug';
import ContentMap from './ContentMap';
import { useAllTopicMap, useTopicsHasLoaded } from './useAllTopics';

interface BaseTopicSubtopicsViewProps {
  topicSlug: string;
}

const BaseTopicSubtopicsView = ({ topicSlug }: BaseTopicSubtopicsViewProps) => {
  const [topicId] = parseSlug(topicSlug);
  const hasLoaded = useTopicsHasLoaded();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const allTopicMap = useAllTopicMap();
  const topic = allTopicMap[topicId];
  const error = !topic && hasLoaded ? 'notFound' : null;

  useEffect(() => {
    if (error === 'notFound') {
      redirectOnNotFoundError({ noun: 'topic', dispatch, navigate });
    }
  }, [error, dispatch, navigate]);

  if (!topic) return null;

  return (
    <PageLayout.Content noPaddingX noPaddingY>
      <PageMeta title={`${topic.name} - Slab`} />
      <ContentMap topicId={topic.id} />
    </PageLayout.Content>
  );
};

const TopicSubtopicsView = () => {
  const { topicSlug } = useParams<{ topicSlug: string }>();
  return topicSlug ? <BaseTopicSubtopicsView topicSlug={topicSlug} /> : null;
};

export default TopicSubtopicsView;
